export default {
    reviewOrder: {
        reviewOrder: "Bestellung überprüfen"
    }
}